import { addNavMenuItem, registerBulkAction } from '@vendure/admin-ui/core';
// import {
//     DeleteBannersBulkAction,
//     DeleteBannerItemsBulkAction,
// } from './bulk-actions';

export default [
    // registerBulkAction(DeleteBannersBulkAction),
    // registerBulkAction(DeleteBannerItemsBulkAction),
    addNavMenuItem(
        {
            id: 'work-brands',
            label: 'Work Brands',
            routerLink: ['/extensions/work-brands'],
            icon: 'image-gallery',
        },
        'marketing'
    ),
];
